import defaultCompleteImg from "../assets/images/default-complete-success.jpg";
import pendingTransactionImg from '../assets/images/transaction-pending.png';
import { FLOW_TYPES, CURRENCY_SELECTORS } from "../utils/enums";
import helpIcon from "../assets/images/circle_questionmark.png";
import underMaintenanceLogo from '../assets/images/maintenance.png';
import moment from 'moment';

/* eslint no-template-curly-in-string: "off" */
const components = {
  // css: {
  //   ':root': {},
  // },
  document: {
    favicon: '/static/media/dp-favicon.ac579acc.ico',
  },
  systemNotifications: {
    enabled: true,
    // notifications: [{message: 'This is a test system notification. Once a notification haqs been viewed and closed, it should not be displayed on subsequent page visits or refreshes for a configurable amount of time. This notification is configured to be supressed for 5 minutes after closing.', suppressSeenNotificationDurationInMinutes: 5}, {message: 'Multiple notifications can be configured per program', suppressSeenNotificationDurationInMinutes: 5}],
    notifications: [],
    suppressSeenNotificationDurationInMinutes: 0,
  },
  systemUnavailable: {
    enabled: false,
    imgSrc: underMaintenanceLogo,
    description: `Due to scheduled maintenance, the system will be unavailable on ${moment().format("dddd, MMMM Do, YYYY")}. Please check back at a later time to process your payment.`,
  },
  header: {
    // logoSrc: <CDN_ASSET_PATH> for header logo
    logoPosition: "left",
    helpIconSrc: helpIcon,
    backgroundColor: '#000',
    reinitializeAppOnLogoClick: true,
  },
  languageSelector: {
    showLanguageSelector: false,
  },
  // title: {
  //   props: {
  //     style: {
  //       background: '#007bff',
  //     },
  //   },
  // },
  footer: {
    footerText: null,
    copyrightPostText: null,
    styles: {},
  },
  loadingPage: {
    imgSrc: null,
  },
  performHealthCheck: {
    title: "Loading Paywall"
  },
  validatePayment: {
    flow: FLOW_TYPES.VALIDATE_PAYMENT.URL_VALIDATION,
    initialVisit: {
      title: 'Loading Paywall'
    },
    returningFromOauth: {
      title: "Fetching User Info"
    }
  },
  paywall: {
    title: "Choose Payment Method",
    showDisabledPaymentNetworks: true, // if set to true, disabled payment networks (based on accounts[paymentNetwork].enabled) will be displayed on paywall
    showMessageForDisabledPaymentNetworks: true, // if set to true, clicking on a disabled network will display the message configured in configuration.paywall.disabledPaymentNetwork
    tile: {
      btnLabel: 'next',
    },
    disabledPaymentNetwork: {
      title: 'Network Unavailable',
      description: 'We’re sorry, ${paymentNetwork.displayName} is temporarily unavailable due to high demand. Please choose another network to immediately receive your funds, or check back on the next business day to retry your payment on ${paymentNetwork.displayName}.'
    },
    byCurrencySelector: {
      CUSTOMER: {
        description: [
          "How would you like to receive your ",
          {
            string: "${payment.amount}",
            transformations: [
              {
                type: "formatAsCurrency",
                data: {
                  currency: "${payment.currency}"
                }
              }
            ],
            props: {
              className: "payment-amount",
            }
          },
          " payment?"
        ]
      },
      RECIPIENT: {
        description: [
          "How would you like to receive your equivalent of ",
          {
            string: "${payment.currency} ",
            props: {
              className: "payment-amount",
            }
          },
          {
            string: "${payment.amount}",
            transformations: [
              {
                type: "formatAsCurrency"
              }
            ],
            props: {
              className: "payment-amount",
            }
          },
          " payment?"
        ],
      }
    }
  },
  recipientLogin: {
    flow: FLOW_TYPES.RECIPIENT_LOGIN.AUTO_LOGIN,
    redirectingToOauth: {
      title: "Redirecting to ${paymentNetwork.displayName}",
      // imgSrc: <CDN_ASSET_PATH> image to display while redirecting to Oauth
    },
    returningFromOauth: {
      title: "Fetching User Info",
      // imgSrc: <CDN_ASSET_PATH> image to display while fetching user info from OAuth token exchange
    },
    loading: {
      title: 'Loading Payment',
    },
    startOverLink: {
      show: true,
    }
  },
  acceptPayment: {
    title: ["Confirm Payment"],
    autoAcceptDurationInSeconds: 10,
    flow: 'basic',
    description: [
      "We will send ",
      {
        string: "${payment.amount}",
        transformations: [
          {
            type: "formatAsCurrency",
            data: {
              currency: "${payment.currency}"
            }
          }
        ],
        props: {
          className: "payment-amount",
        }
      },
      " to your ",
      {
        string: "${paymentNetwork.displayName}",
        props: {
          className: 'payment-paymentNetwork',
        }
      },
      " account."
    ],
    btnLabel: "Apply to ${paymentNetwork.displayName}",
    buttons: [
      {
        label: "Apply to ${paymentNetwork.displayName}"
      }
    ],
    errorMessages: {},
    imgSrc: defaultCompleteImg,
    byCurrencySelector: {
      [CURRENCY_SELECTORS.RECIPIENT]: {
        description: [
          "We will send ",
          {
            string: "${payment.amount}",
            transformations: [
              {
                type: "formatAsCurrency",
                data: {
                  currency: "${payment.currency}"
                }
              }
            ],
            props: {
              className: "payment-amount",
            }
          },
          " to your ",
          {
            string: "${paymentNetwork.displayName}",
            props: {
              className: 'payment-paymentNetwork',
            }
          },
          " account."
        ],
        currencyOptions: [
          {
            value: 'USD',
            label: 'United States dollar',
          },
          {
            value: 'AUD',
            label: 'Australian dollar',
          },
          {
            value: 'BRL',
            label: 'Brazilian real',
          },
          {
            value: 'CAD',
            label: 'Canadian dollar',
          },
          {
            value: 'CZK',
            label: 'Czech koruna',
          },
          {
            value: 'DKK',
            label: 'Danish krone',
          },
          {
            value: 'EUR',
            label: 'Euro',
          },
          {
            value: 'HKD',
            label: 'Hong Kong dollar',
          },
          {
            value: 'HUF',
            label: 'Hungarian forint',
          },
          {
            value: 'ILS',
            label: 'Israeli new shekel',
          },
          {
            value: 'JPY',
            label: 'Japanese yen',
          },
          {
            value: 'MXN',
            label: 'Mexican peso',
          },
          {
            value: 'TWD',
            label: 'New Taiwan dollar',
          },
          {
            value: 'NZD',
            label: 'New Zealand dollar',
          },
          {
            value: 'NOK',
            label: 'Norwegian krone',
          },
          {
            value: 'PHP',
            label: 'Philippine peso',
          },
          {
            value: 'PLN',
            label: 'Polish złoty',
          },
          {
            value: 'GBP',
            label: 'Pound sterling',
          },
          {
            value: 'RUB',
            label: 'Russian ruble',
          },
          {
            value: 'SGD',
            label: 'Singapore dollar',
          },
          {
            value: 'SEK',
            label: 'Swedish krona',
          },
          {
            value: 'CHF',
            label: 'Swiss franc',
          },
          {
            value: 'THB',
            label: 'Thai baht',
          },
        ]
      }
    }
  },
  paymentComplete: {
    imgSrc: defaultCompleteImg,
    title: ["Payment Complete"],
    initial: {
      description: [
        "Success! We sent ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        " to your ",
        {
          string: "${paymentNetwork.displayName}",
          props: {
            className: 'payment-paymentNetwork',
          }
        },
        " account."
      ],
      secondaryText: [
        "A confirmation will be ",
        {
          string: "${payment.recipientNotificationPreference}",
          transformations: [
            {
              type: 'formatPaymentNetworkRecipientType',
            }
          ],
        },
        {
          string: "${payment.recipientNotificationPreference}",
          transformations: [
            {
              type: 'formatEmailAddressOrMobilePhoneNumber',
            },
          ],
          props: {
            className: 'payment-recipientEmail'
          }
        },
        "."
      ]
    },
    revisit: {
      description: [
        "We sent ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        " to your ",
        {
          string: "${paymentNetwork.displayName}",
          props: {
            className: 'payment-paymentNetwork',
          }
        },
        " account."
      ],
      secondaryText: [
        "A confirmation was ",
        {
          string: "${payment.recipientNotificationPreference}",
          transformations: [
            {
              type: 'formatPaymentNetworkRecipientType',
            },
          ],
        },
        {
          string: "${payment.recipientNotificationPreference}",
          transformations: [
            {
              type: 'formatEmailAddressOrMobilePhoneNumber',
            },
          ],
          props: {
            className: 'payment-recipientEmail'
          }
        },
        " on ",
        {
          string: "${payment.updatedAt}",
          transformations: [
            {
              type: "formatDate"
            }
          ],
          props: {
            className: 'payment-updatedAt'
          }
        },
        "."
      ]
    }
  },
  networkSelectionAccepted: {
    imgSrc: pendingTransactionImg,
    title: ["Success!"],
    description: [
      "Please check your email ",
      {
        string: "${payment.recipientNotificationPreference}",
        transformations: [
          {
            type: 'formatEmailAddressOrMobilePhoneNumber',
          }
        ],
        props: {
          className: 'payment-recipientEmail'
        }
      },
      " for details regarding your ",
      {
        string: "${paymentNetwork.displayName}",
        props: {
          className: 'payment-paymentNetwork',
        }
      },
      " for ",
      {
        string: "${payment.acceptedAmount}",
        transformations: [
          {
            type: "formatAsCurrency",
            data: {
              currency: "${payment.acceptedCurrency}"
            }
          }
        ],
        props: {
          className: "payment-amount",
        }
      },
      ". It should arrive within 24 to 48 hours and will include details for your use."
    ],
    secondaryText: [
      "Upon receipt, please treat this eGift card like cash and care for it accordingly to avoid loss or theft.",
    ]
  },
  pendingTransaction: {
    title: ["Payment Pending"],
    imgSrc: pendingTransactionImg,
    secondaryText: [
      "Some payments take a few extra moments, especially when demand is high. Please check your email for deposit confirmation or links to active digital debit and retail gift cards."
    ]
  },
  pollingForComplete: {
    pollingIntervalInSeconds: 5,
    pollingDurationInSeconds: 20,
    title: "Transferring Funds",
    description:
      "Please be patient. It may take up to 30 seconds to complete the transaction."
  },
  onHold: {
    title: 'Your Funds Will Arrive Soon',
    description: 'Your payment is in review due to account validation or authorization. This process usually takes 48 hours or less.',
    secondaryText: ' ',
  },
  twoFactorAuthentication: {
    title: 'Receive with Venmo™',
    description: [
      "Please enter the 10-digit mobile number associated with your ",
      {
        string: "${paymentNetwork.displayName}",
        props: {
          className: 'payment-paymentNetwork'
        }
      },
      " account."
    ],
    secondaryText: [
      {
        string: 'If you do not have a Venmo™ account, you will receive a text message to create an account and claim your payment. For more information regarding Venmo™ and creating an account, please refer to the FAQs, or visit <a href=\'https://venmo.com\'>https://venmo.com</a>.',
        props: {
          style: { fontSize: 14, lineHeight: 1, color: 'gray', fontStyle: 'italic' }
        }
      }
    ],
  }
};

export default components;
